
export const commonPage = {
  'vip': '/vip',
  // 奖励中心
  'reward': '/reward',
  'casino': '/casino',
  'sports': '/sports',
  'fantasy': '/fantasy',
  'rummy': '/rummy',
  'download': '/download',
  // 短视频平台Global Star Lab
  'gsl': '/gsl',
  // 旧代理页面
  'affiliateOld': '/affiliate/agent',
  // 代理里程碑规则
  'affiliateRule': '/affiliate/rule',
};

export const menuTabUrl = {
  'home': '/',
  'casino': '/casino',
  'fantasy': '/fantasy',
  'sports': '/sports',
  'rummy': '/rummy',
};

export const casino = {
  'games': '/casino/games',
  'groups': '/casino/groups',
  'gamePlay': '/casino/games/play'
};

export const loginPage = {
  'login': '/login',
};

// 活动页面
export const activityPage = {
  // 累充转盘
  'cumulativeDeposit': '/deposit-spin',
  // 裂变转盘
  'lottery': '/referral-wheel',
};

// 游戏中的页面，余额显示需要隐藏
export const inPlayPages = [
  'fantasy/play',
  'casino/games/detail',
  '/casino/games/play',
  'rummy',
  'sports'
];

// 需要显示footer的页面
export const showFooterPages = [
  '/',
  '/casino',
  '/casino/games',
  '/casino/games/detail',
  '/casino/games/container',
  '/casino/games',
  '/reward',
];
